import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { useGetContentItemQuery } from 'common/store/modules/api/content-api';
import { LazyImage } from 'common/react/components/LazyImage';
import { useBettingVis } from 'common/react/hooks/use-betting-vis';
import { SponsorSkeleton } from './SponsorSkeleton';
import { useSingleSiteSetting } from 'common/react/hooks/use-single-site-setting';

export const Sponsor = ({ promoId, cssClass }) => {
    const sponsorRef = useRef();
    const isBettingVisible = useBettingVis();
    const isOver18 = useSingleSiteSetting('over18');

    const { data: promo, isFetching: isFetchingPromoData } =
        useGetContentItemQuery({
            type: 'PROMO',
            id: promoId
        });

    const isBettingSponsor =
        PULSE.app.common.content.hasBettingSponsorTag(promo);
    const isAlcoholSponsor =
        PULSE.app.common.content.hasAlcoholSponsorTag(promo);
    const promoLink = promo?.links[0];
    const target = promoLink?.external ? '_blank' : null;

    useEffect(() => {
        if (sponsorRef.current) {
            PULSE.app.analytics.addSponsorTracking(sponsorRef.current);
        }
    }, [promo, sponsorRef]);

    if (
        (isBettingSponsor && !isBettingVisible) ||
        (isAlcoholSponsor && !isOver18)
    ) {
        return null;
    }

    return isFetchingPromoData ? (
        <SponsorSkeleton cssClass={cssClass} />
    ) : (
        <>
            {promo ? (
                <>
                    {/* <SponsorSkeleton cssClass={cssClass} /> */}
                    <div
                        className="content-sponsor content-sponsor--without-borders content-sponsor--without-padding"
                        ref={sponsorRef}
                    >
                        {promo.title && promo.title !== '' ? (
                            <h2 className="content-sponsor__title">
                                {promo.title}
                            </h2>
                        ) : null}
                        {promoLink?.promoUrl ? (
                            <a
                                className="content-sponsor__image-link js-tracked-sponsor-item"
                                href={promoLink.promoUrl}
                                target={target}
                                title={promo.linkText || ''}
                                data-type={
                                    PULSE.app.common.CONSTANTS.TRACKING
                                        .CONTENT_TYPES.LINEUPS_SPONSOR
                                }
                                data-component-name={
                                    PULSE.app.common.CONSTANTS.TRACKING
                                        .CONTENT_TYPES.TEAM_LINEUP_CONDENSED
                                }
                                data-component-content-type={
                                    PULSE.app.common.CONSTANTS.TRACKING
                                        .CONTENT_TYPES.MATCH_INFO
                                }
                                data-link-text={`${promo.title || ''} ${
                                    promoLink.linkText || ''
                                }`}
                                data-name={promoLink.linkText || ''}
                            >
                                {promo?.promoItem?.onDemandUrl ? (
                                    <LazyImage
                                        url={`${promo.promoItem.onDemandUrl}?height=108`}
                                        cssClass="content-sponsor__image"
                                        objectFit={false}
                                    />
                                ) : null}
                                {promoLink.linkText ? (
                                    <span className="u-screen-reader">
                                        {promoLink.linkText}
                                    </span>
                                ) : null}
                            </a>
                        ) : (
                            <div className="content-sponsor__image-link">
                                {promo?.promoItem?.onDemandUrl ? (
                                    <LazyImage
                                        url={`${promo.promoItem.onDemandUrl}?height=108`}
                                        cssClass="content-sponsor__image"
                                        objectFit={false}
                                    />
                                ) : null}
                                {promoLink?.linkText ? (
                                    <span className="u-screen-reader">
                                        {promoLink.linkText}
                                    </span>
                                ) : null}
                            </div>
                        )}
                    </div>
                </>
            ) : null}
        </>
    );
};

Sponsor.propTypes = {
    promoId: PropTypes.string.isRequired,
    cssClass: PropTypes.string
};
